import { render, staticRenderFns } from "./selectFacesDente.vue?vue&type=template&id=101acd20&scoped=true"
import script from "./selectFacesDente.vue?vue&type=script&lang=js"
export * from "./selectFacesDente.vue?vue&type=script&lang=js"
import style0 from "./selectFacesDente.vue?vue&type=style&index=0&id=101acd20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101acd20",
  null
  
)

export default component.exports